/* eslint-disable @typescript-eslint/no-explicit-any */
import { getIdSports } from '../../../common/data/sports';
import { getModel } from '../../../services/api.service';
import { getModel as getModel2 } from '../../../services/api2.service';
import { IListClubSlotReturn, IListFieldReturn, IListPriceSlotReturn, ISlotPrice } from '../interfaces/field';

export interface fieldsAvailablesParams {
    sport?: string;
    clubId?: string;
    fieldId?: string;
    withMap?: string;
    daysLimit?: number;
    startHour?: string;
}

export interface clubSlotParams {
    clubId?: string;
    date?: string;
    sport?: string;
    moduleCall?: 'CHALLENGE';
}

export interface priceSlotParams {
    pricesId?: string;
}

/**
 * Get all fields availables by sport
 */
export const getAllFieldsAvailables = async ({
    sport,
    clubId,
    fieldId,
    daysLimit,
    startHour,
}: fieldsAvailablesParams): Promise<IListFieldReturn> => {
    /*console.log({
        sport,
        clubId,
        fieldId,
        daysLimit,
        startHour,
    } )*/
    let urlModel = `sliders/fields/slots/available`;
    const sportId = getIdSports(sport);
    const query: any[] = [];

    if (startHour) {
        query.push({ key: 'startHour', value: startHour });
    }

    if (daysLimit) {
        query.push({ key: 'daysLimit', value: daysLimit });
    }

    if (sportId) {
        query.push({ key: 'sportId', value: sportId });
    }

    if (clubId) {
        query.push({ key: 'clubId', value: clubId });
    }

    if (fieldId) {
        query.push({ key: 'fieldId', value: fieldId });
    }

    if (query && query.length > 0) {
        query.forEach((e, i) => {
            urlModel = i === 0 ? `${urlModel}?${e.key}=${e.value}` : `${urlModel}&${e.key}=${e.value}`;
        });
    }

    const data = await getModel2(urlModel);
    return data;
};

/**
 * Get all fields availables by sport
 */
export const getClubSlots = async ({
    clubId,
    date,
    sport,
    moduleCall,
}: clubSlotParams): Promise<IListClubSlotReturn> => {
    const sportId = getIdSports(sport);
    const urlModel = `clubs/slots?clubId=${clubId}&date=${date}&sportId=${sportId}&moduleCall=${moduleCall || ''}`;
    const data = await getModel2(urlModel);
    return data;
};

/**
 * Get all fields availables by sport
 */
export const getSlotAllPrices = async (value: ISlotPrice): Promise<IListPriceSlotReturn> => {
    const urlModel = `fields/slots/prices?prices=${value.pricesId}&calculateFor=${value.calculateFor}&clubId=${value.clubId}`;
    const data = await getModel(urlModel);
    return data;
};
